export const phishingSimulations = [
  {
    id: "PS001",
    simulationName: "Urgent: Password Expiry",
    templateUsed: "IT Helpdesk - Credential Reset",
    targetGroup: "All Employees",
    sendDate: "2023-10-15",
    deliveryStatus: "Delivered",
    openRate: 71.1,
    clickRate: 14.1,
    credentialSubmissionRate: 6.2,
    reportRate: 33.3,
    failureRate: 14.1,
    status: "Completed",
    sent: 450,
    opened: 320,
    clicked: 45,
    submitted: 28,
    reported: 150,
  },
  {
    id: "PS002",
    simulationName: "Q3 Benefits Update",
    templateUsed: "HR Internal Announcement",
    targetGroup: "All Employees",
    sendDate: "2023-11-02",
    deliveryStatus: "Delivered",
    openRate: 62.2,
    clickRate: 4.3,
    credentialSubmissionRate: 1.1,
    reportRate: 46.7,
    failureRate: 4.3,
    status: "Completed",
    sent: 450,
    opened: 280,
    clicked: 12,
    submitted: 5,
    reported: 210,
  },
  {
    id: "PS003",
    simulationName: "IT: Mandatory Software Update",
    templateUsed: "IT Department - Urgent Action",
    targetGroup: "Engineering & IT",
    sendDate: "2023-11-20",
    deliveryStatus: "Delivered",
    openRate: 84.8,
    clickRate: 21.8,
    credentialSubmissionRate: 8.7,
    reportRate: 19.6,
    failureRate: 21.8,
    status: "Completed",
    sent: 460,
    opened: 390,
    clicked: 85,
    submitted: 40,
    reported: 90,
  },
  {
    id: "PS004",
    simulationName: "Holiday Bonus Details",
    templateUsed: "Finance - Employee Reward",
    targetGroup: "Sales & Marketing",
    sendDate: "2023-12-05",
    deliveryStatus: "Partial",
    openRate: 25.8,
    clickRate: 4.2,
    credentialSubmissionRate: 0.9,
    reportRate: 8.6,
    failureRate: 4.2,
    status: "Active",
    sent: 465,
    opened: 120,
    clicked: 5,
    submitted: 4,
    reported: 40,
  },
];